module.exports = __webpack_public_path__ + "static/illustration-1.786c5e6e.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/illustration-1.png
// module id = 1020
// module chunks = 2